/**
 * Product Service
 * 
 * Provides functionality for working with product data.
 */

import { apiClient } from '../../core/api/client';
import { ApiService } from '../../core/api/service';
import { ApiResponse } from "../../../model";
import {
    ProductCreateProductsRequest,
    ProductCreateProductsResponse,
    ProductDeleteProductsRequest,
    ProductDeleteProductsResponse,
    ProductGetProductRequest,
    ProductGetProductResponse, 
    ProductSearchRequest,
    ProductSearchResponse,
    ProductUpdateProductsRequest,
    ProductUpdateProductsResponse
} from "../../../model/product/dto/product-api";

export class ProductService extends ApiService {
  /**
   * Search products based on criteria
   */
  async search(request: ProductSearchRequest): Promise<ProductSearchResponse[] | null> {
    try {
      const response = await apiClient.post<ApiResponse<ProductSearchResponse[]>>(
        '/api/product/search',
        request
      );
      
      return this.processResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }
  
  /**
   * Get product details by ID or code
   */
  async getProduct(
    request: ProductGetProductRequest
  ): Promise<ProductGetProductResponse | null> {
    try {
      const response = await apiClient.post<ApiResponse<ProductGetProductResponse>>(
        '/api/product/getProduct',
        request
      );
      
      return this.processResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }
  
  /**
   * Create new products
   */
  async createProducts(
    request: ProductCreateProductsRequest
  ): Promise<ProductCreateProductsResponse | null> {
    try {
      const response = await apiClient.post<ApiResponse<ProductCreateProductsResponse>>(
        '/api/product/create',
        request
      );
      
      return this.processResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }
  
  /**
   * Update existing products
   */
  async updateProducts(
    request: ProductUpdateProductsRequest
  ): Promise<ProductUpdateProductsResponse | null> {
    try {
      const response = await apiClient.post<ApiResponse<ProductUpdateProductsResponse>>(
        '/api/product/update',
        request
      );
      
      return this.processResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }
  
  /**
   * Delete products
   */
  async deleteProducts(
    request: ProductDeleteProductsRequest
  ): Promise<ProductDeleteProductsResponse | null> {
    try {
      const response = await apiClient.post<ApiResponse<ProductDeleteProductsResponse>>(
        '/api/product/delete',
        request
      );
      
      return this.processResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }
}

// Export a singleton instance
export const productService = new ProductService();
